import { StandardAddress } from '../../home/generated/types/api';

export const confirmPasswordInitialValues = {
  new_password: '',
  confirm_password: ''
};

export const nameInitialValues = {
  first_name: '',
  last_name: ''
};

export const addressInitialValues: Omit<
  StandardAddress,
  'id' | 'customer_id' | 'first_name' | 'last_name' | 'email' | 'phone' | 'metadata'
> = {
  company: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postal_code: '',
  country: 'US',
  is_default: false
};
